export * from './is-apple';
export * from './is-ios';
